<template>
    <div :class="{inline: inline}">
        <div class="radio-item" :class="{active: item.active,inline: inline}" v-for="(item,index) in list" :key="item.label" @click="select(index)">{{item.label}}</div>
    </div>
</template>

<script>
    // @ is an alias to /src
    export default {
        name: 'checkbox',
        props: {
            data: {
                default: [],
                type: Array
            },
            inline: {
                default: false,
                type: Boolean
            }
        },
        data: () => ({
            list: []
        }),
        methods: {
            select(index) {
                this.list.forEach((v,i) => {
                    if (i == index) {
                        this.$set(v, 'active', true) 
                        this.$emit('change', v.value)
                        
                    } else {
                        this.$set(v, 'active', false)
                    }
                })
               
            }
        },
        computed: {

        },
        watch: {
            data: {
                handler (val) {
                    this.list = this.data.map(v=>({...v,active: v.default ? true : false}))
                },
                immediate:true
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>
    .inline {
        display: inline-block;
    }
    .radio-item {
        margin-right: 10px;
    }
    .radio-item::before {
        content: '';
        display: inline-block;
        width: 12px;
        height: 12px;
        background-color: white;
        border: 1px solid #666;
        border-radius: 100%;
        box-shadow: 0 0 0 2px white inset;
        vertical-align: baseline;
        margin-right: 6px;
    }

    .radio-item.active::before {
        background-color: #0082da;
    }
</style>